import React from "react";
import { RoundTripFlightMatch } from "../../models/RoundTripFlightMatch";
import RoundTripComparisonItem from "./RoundTripComparisonListItem";
import DestinationGroupHeader from "../cards/destinationGroupHeader";
import { getDestinationGroupHeaderURL } from "../../utils/GetImageUrl";
import {DestinationCategory} from "../../models/DestinationCategory";

interface Props {
  city: string;
  flightMatches: RoundTripFlightMatch[];
}

const DestinationGroup: React.FC<Props> = ({ city, flightMatches }) => {
  const categories: DestinationCategory[] = flightMatches[0]?.categories || [];
  const trip = flightMatches[0]?.round_trip_flight;
  const legs = trip?.outbound_flights;
  const destinationIata = (legs?.length ? legs[legs.length - 1].destination_iata : trip?.outbound_flight.destination_iata) || "";
  const backgroundImageUrl = getDestinationGroupHeaderURL(destinationIata);

  return (
    <div className="w-full flex flex-col gap-3 transition-all duration-300">
      <DestinationGroupHeader
        city={city}
        destinationIata={destinationIata}
        totalFlights={flightMatches.length}
        backgroundImageUrl={backgroundImageUrl}
        categories={categories}
      />

      <div className="flex flex-col gap-3">
        {flightMatches.map((flight, idx) => (
          <RoundTripComparisonItem key={idx} roundTripFlightMatch={flight} />
        ))}
      </div>
    </div>
  );
};

export default DestinationGroup;
